import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './LoadingSpinner.module.css';

interface LoadingSpinnerProps {
  global?: boolean;
  hideLoadingMessage?: boolean;
  className?: string;
  testId?: string;
  size?: number;
}

const LoadingSpinnerTestIds = {
  wrapper: 'loading-spinner',
};

export default function LoadingSpinner({
  global = false,
  hideLoadingMessage = false,
  className = '',
  testId = LoadingSpinnerTestIds.wrapper,
  size = 75,
}: LoadingSpinnerProps) {
  const { t } = useTranslation();
  const showLoadingMessage = !hideLoadingMessage && !global;
  return (
    <div className={cx(styles.loadingSpinner, { [styles.global]: global }, className)} data-testid={testId}>
      <div className={styles.content}>
        {showLoadingMessage && (
          <div className={styles.message}>
            <p>{t('global.loading.line1')}</p>
            <p>{t('global.loading.line2')}</p>
          </div>
        )}
        <img src="/gifs/spinner.gif" width={size} height={size} alt="Loading..." />
      </div>
    </div>
  );
}

/**
 * @summary Inline styling based fallback spinner, use in nested child components only,
 * because we are chunking the main LoadingSpinner with S(CSS) file dependencies. Which causes
 * vite to bubble up to a higher Suspense boundary, potentially causing the entire page to re-render.
 */
export const LoadingSpinnerFallback = ({ testId = LoadingSpinnerTestIds.wrapper, size = 75 }: LoadingSpinnerProps) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    data-testid={testId}
  >
    <img src="/gifs/spinner.gif" width={size} height={size} alt="Loading..." />
  </div>
);
